export const payroll: Record<string, string> = {
  // Pages and navigation
  'Pay run': 'Cycle de paie',
  'Pay bands': 'Grilles salariales',
  'Pay band': 'Grille salariale',
  'Timesheets': 'Feuilles de temps',
  'Payroll rules': 'Règles de paie',
  'Rules': 'Règles',

  // Pay bands page
  'Bands': 'Grilles',
  'Band': 'Grille',
  'Band rate': 'Taux de la grille',
  'New pay band': 'Nouvelle grille salariale',
  'Create pay band': 'Créer la grille salariale',
  'Pay band created.': 'Grille salariale créée.',
  'Opening hourly rate': 'Taux horaire initial',
  'Current rate': 'Taux actuel',
  'Rate history': 'Historique des taux',
  '{name} rate history': 'Historique des taux : {name}',
  'New rate': 'Nouveau taux',
  'New rate scheduled.': 'Nouveau taux planifié.',
  'Schedule rate': 'Planifier le taux',
  'No rates recorded.': 'Aucun taux enregistré.',
  'Effective': 'En vigueur',
  'Effective from': 'En vigueur à partir du',
  '{from} → open': '{from} → en cours',
  'Note': 'Remarque',
  'Default': 'Par défaut',
  'Inactive': 'Inactive',
  'Loading pay bands...': 'Chargement des grilles salariales...',
  'No pay bands yet. Create one to get started.':
    'Aucune grille salariale pour le moment. Créez-en une pour commencer.',
  'Select a band to see its rate history and assigned employees.':
    'Sélectionnez une grille pour voir son historique de taux et les employés affectés.',
  'Select a pay band to see its rates.': 'Sélectionnez une grille salariale pour voir ses taux.',
  'Select a pay band first.': 'Sélectionnez d’abord une grille salariale.',
  'Adding a rate closes the previous one the day before, so the windows never overlap.':
    'L’ajout d’un taux clôture le précédent la veille, afin que les périodes ne se chevauchent jamais.',
  'The opening rate starts today. Schedule future changes from the rate history.':
    'Le taux initial s’applique dès aujourd’hui. Planifiez les changements futurs depuis l’historique des taux.',
  'Group employees into pay grades with their own rates. Rates are effective dated, so historic payroll runs keep reporting what was actually paid.':
    'Regroupez les employés en échelons de rémunération avec leurs propres taux. Les taux sont datés, afin que les cycles de paie passés continuent de refléter ce qui a réellement été payé.',
  'Give the pay band a code and a name.': 'Donnez un code et un nom à la grille salariale.',
  'Enter a valid hourly rate.': 'Saisissez un taux horaire valide.',
  'Failed to load pay bands': 'Échec du chargement des grilles salariales',
  'Static Guard Tier 1': 'Agent statique niveau 1',

  // Assignments
  'Employee assignments': 'Affectations des employés',
  'Assign employee': 'Affecter l’employé',
  'Employee assigned to pay band.': 'Employé affecté à la grille salariale.',
  'Select employee': 'Sélectionner un employé',
  'Choose an employee to assign.': 'Choisissez un employé à affecter.',
  'Choose a pay band.': 'Choisissez une grille salariale.',
  'No assignments yet.': 'Aucune affectation pour le moment.',
  'Rate override (optional)': 'Taux dérogatoire (facultatif)',
  'Override': 'Dérogation',
  'Employment type': 'Type de contrat',
  'Payroll reference': 'Référence de paie',
  'Reference': 'Référence',
  'Cost centre': 'Centre de coûts',
  'Full time': 'Temps plein',
  'Part time': 'Temps partiel',
  'Relief': 'Remplacement',
  'Contractor': 'Prestataire',
  'Apprentice': 'Apprenti',
  'Assign an employee to a band from a date. An individual rate override replaces the band rate but keeps its premium structure.':
    'Affectez un employé à une grille à partir d’une date. Un taux dérogatoire individuel remplace le taux de la grille tout en conservant sa structure de majorations.',
  '1 employee has no pay band and will fall back to the company base rate.':
    '1 employé n’a pas de grille salariale et utilisera le taux de base de l’entreprise.',
  '{count} employees have no pay band and will fall back to the company base rate.':
    '{count} employés n’ont pas de grille salariale et utiliseront le taux de base de l’entreprise.',

  // Pay periods and timesheets
  'Pay periods': 'Périodes de paie',
  'New pay period': 'Nouvelle période de paie',
  'New period': 'Nouvelle période',
  'Pay period created.': 'Période de paie créée.',
  'Pay period updated.': 'Période de paie mise à jour.',
  'Period': 'Période',
  'Dates': 'Dates',
  'Label': 'Libellé',
  'Week 12': 'Semaine 12',
  'Create': 'Créer',
  'Recalculate': 'Recalculer',
  'Approve period': 'Approuver la période',
  'Lock period': 'Verrouiller la période',
  'Approved by': 'Approuvé par',
  'Loading pay periods...': 'Chargement des périodes de paie...',
  'No pay periods yet. Create one to start a payroll run.':
    'Aucune période de paie pour le moment. Créez-en une pour lancer un cycle de paie.',
  'Select a period to review its timesheets.':
    'Sélectionnez une période pour examiner ses feuilles de temps.',
  'Select a pay period first.': 'Sélectionnez d’abord une période de paie.',
  'Give the pay period a label.': 'Donnez un libellé à la période de paie.',
  'The start date must be before the end date.':
    'La date de début doit précéder la date de fin.',
  'Timesheets recalculated from shift records.':
    'Feuilles de temps recalculées à partir des vacations enregistrées.',
  'No timesheets yet. Use Recalculate to build them from shift records.':
    'Aucune feuille de temps. Utilisez Recalculer pour les générer à partir des vacations.',
  'Open a row to see its pay lines, add adjustments and view the audit trail.':
    'Ouvrez une ligne pour voir ses lignes de paie, ajouter des ajustements et consulter le journal d’audit.',
  'Review calculated hours per employee, add non-shift pay, and approve the period. Locking a period freezes its figures so exports cannot drift.':
    'Vérifiez les heures calculées par employé, ajoutez les rémunérations hors vacation, puis approuvez la période. Le verrouillage fige les montants afin que les exports ne dérivent pas.',
  'Failed to load pay periods': 'Échec du chargement des périodes de paie',
  'Failed to load timesheets': 'Échec du chargement des feuilles de temps',
  'Failed to load timesheet detail': 'Échec du chargement du détail de la feuille de temps',
  'Timesheet approved.': 'Feuille de temps approuvée.',
  'Approve {employee} with exceptions?': 'Approuver {employee} avec des exceptions ?',
  '{count} flagged pay line(s) remain. Record why they are acceptable; the note will be retained in the audit trail.':
    '{count} ligne(s) de paie signalée(s) subsistent. Indiquez pourquoi elles sont acceptables ; la note sera conservée dans la piste d’audit.',
  'Approval note': 'Note d’approbation',
  'Explain why the exceptions are acceptable for this run':
    'Expliquez pourquoi les exceptions sont acceptables pour ce traitement',
  'Explain why the remaining exceptions are acceptable for this pay run.':
    'Expliquez pourquoi les exceptions restantes sont acceptables pour ce traitement de paie.',
  'Approve with note': 'Approuver avec une note',
  'Timesheet updated.': 'Feuille de temps mise à jour.',
  'Returned for correction': 'Retournée pour correction',
  'Approve': 'Approuver',
  'Reject': 'Rejeter',

  // Timesheet statuses (rendered from data)
  'draft': 'brouillon',
  'submitted': 'soumise',
  'approved': 'approuvée',
  'rejected': 'rejetée',
  'locked': 'verrouillée',
  'open': 'ouverte',
  'in_review': 'en révision',
  'paid': 'payée',

  // Audit event types (rendered from data)
  'calculated': 'calculée',
  'entry_added': 'ligne ajoutée',
  'entry_edited': 'ligne modifiée',
  'entry_removed': 'ligne supprimée',
  'reopened': 'rouverte',
  'exported': 'exportée',
  'System': 'Système',
  'Audit trail': 'Journal d’audit',
  'No changes recorded yet.': 'Aucune modification enregistrée pour le moment.',

  // Pay lines
  'Pay lines': 'Lignes de paie',
  'No pay lines.': 'Aucune ligne de paie.',
  'Add non-shift pay': 'Ajouter une rémunération hors vacation',
  'Add entry': 'Ajouter la ligne',
  'Entry added.': 'Ligne ajoutée.',
  'Describe the entry.': 'Décrivez la ligne.',
  'Entry type': 'Type de ligne',
  'Training': 'Formation',
  'Standby': 'Astreinte',
  'Call-out': 'Intervention',
  'Bonus': 'Prime',
  'Expense': 'Frais',
  'Deduction': 'Retenue',
  'Adjustment': 'Ajustement',
  'Units': 'Unités',
  'Unit amount': 'Montant unitaire',
  'Hourly rate': 'Taux horaire',

  // Run page and columns
  'Calculate hours, premiums and overtime from clocked shift records, then export in the layout your payroll bureau expects.':
    'Calculez les heures, majorations et heures supplémentaires à partir des pointages, puis exportez dans le format attendu par votre prestataire de paie.',
  'Defaults follow current Irish security-sector payroll rules. Pay bands can override the premium values per grade.':
    'Les valeurs par défaut suivent les règles de paie du secteur irlandais de la sécurité. Les grilles salariales peuvent redéfinir les majorations par échelon.',
  'Shift detail': 'Détail des vacations',
  'Timesheet register': 'Registre des feuilles de temps',
  'Cost centre breakdown': 'Ventilation par centre de coûts',
  'One row per shift with hours, premiums and pay.':
    'Une ligne par vacation avec heures, majorations et rémunération.',
  'One row per employee for the period.': 'Une ligne par employé pour la période.',
  'Approval status and totals per timesheet.':
    'Statut d’approbation et totaux par feuille de temps.',
  'Hours and pay grouped by cost centre and site.':
    'Heures et rémunération regroupées par centre de coûts et par site.',

  'Aggregate breakdown': 'Ventilation agrégée',
  'Aggregate report': 'Rapport agrégé',
  'Approved figures rolled up across the period.':
    'Montants approuvés consolidés sur la période.',
  'The same run grouped a different way, for cost allocation and reporting.':
    'Le même cycle regroupé différemment, pour l’imputation des coûts et le reporting.',
  'Nothing to aggregate yet.': 'Rien à agréger pour le moment.',
  'Employees': 'Employés',

  'Ordinary': 'Normales',
  'Ordinary hours': 'Heures normales',
  'Ordinary pay': 'Rémunération normale',
  'Overtime': 'Heures supp.',
  'Overtime hours': 'Heures supplémentaires',
  'Overtime pay': 'Rémunération des heures supplémentaires',
  'Premium pay': 'Majorations',
  'OT': 'HS',
  'Gross': 'Brut',
  'Gross pay': 'Rémunération brute',
  'Amount payable': 'Montant à payer',
  'Rate': 'Taux',
  'Clocked': 'Pointé',
  'Paid window': 'Plage rémunérée',
  'Variance': 'Écart',
  'Rounding': 'Arrondi',
  'Flags': 'Signalements',
  'Clock in': 'Pointage entrée',
  'Clock out': 'Pointage sortie',
  'Lines to review': 'Lignes à vérifier',

  // Settings
  'Base and premiums': 'Base et majorations',
  'Rounding and tolerance': 'Arrondi et tolérance',
  'Daily overtime after (hours)': 'Heures supp. journalières au-delà de (heures)',
  'Weekly overtime after (hours)': 'Heures supp. hebdomadaires au-delà de (heures)',
  'Weekly overtime multiplier': 'Coefficient des heures supplémentaires hebdomadaires',
  'Overtime week starts': 'Début de la semaine d’heures supplémentaires',
  'Overtime multiplier': 'Coefficient des heures supplémentaires',
  'Double time after (hours)': 'Taux double au-delà de (heures)',
  'Double time multiplier': 'Coefficient du taux double',
  'Rounding interval (minutes)': 'Intervalle d’arrondi (minutes)',
  'Clock-in grace (minutes)': 'Tolérance à l’entrée (minutes)',
  'Clock-out grace (minutes)': 'Tolérance à la sortie (minutes)',
  'Flag variance over (minutes)': 'Signaler un écart supérieur à (minutes)',
  'Annual leave accrual (%)': 'Acquisition de congés annuels (%)',
  'No rounding': 'Aucun arrondi',
  'Nearest': 'Au plus proche',
  'Round up': 'Arrondir au supérieur',
  'Round down': 'Arrondir à l’inférieur',
  'Enable overtime': 'Activer les heures supplémentaires',
  'Enable double time': 'Activer le taux double',
  'Snap clock times within grace to the schedule':
    'Aligner sur l’horaire prévu les pointages dans la tolérance',
  'Track annual leave accrual': 'Suivre l’acquisition des congés annuels',

  // Review flags (rendered from data)
  'Missing clock-in': 'Pointage d’entrée manquant',
  'Missing clock-out': 'Pointage de sortie manquant',
  'Invalid clock interval': 'Intervalle de pointage invalide',
  'Shift not yet worked': 'Vacation pas encore effectuée',
  'Shift in progress': 'Vacation en cours',
  'Incomplete break clock': 'Pointage de pause incomplet',
  'Unconfirmed unpaid break': 'Pause non payée non confirmée',
  'Invalid break interval': 'Intervalle de pause invalide',
  'Break clock outside shift': 'Pointage de pause hors de la vacation',
  'Overlapping unpaid breaks': 'Pauses non payées qui se chevauchent',
  'Unpaid break not taken': 'Pause non payée non prise',
  'Cancelled shift': 'Vacation annulée',
  'Auto-closed, no clock-out': 'Clôturée automatiquement, pointage de sortie manquant',
  'No pay band assigned': 'Aucune grille salariale affectée',
  'Snapped to schedule': 'Aligné sur l’horaire prévu',
  'Sunday premium rate unset': 'Majoration du dimanche non définie',
  'Public holiday premium rate unset': 'Majoration de jour férié non définie',
  'Unsocial hours below shift threshold':
    'Heures atypiques sous le seuil de la vacation',
  'Minimum shift pay top-up applied':
    'Complément de rémunération minimale appliqué',
  'Security ERO hourly rate floor applied':
    'Minimum horaire de l’ERO sécurité appliqué',
  'Paid hours differ from schedule': 'Heures payées différentes de l’horaire prévu',

  // Controlled workflow and gross-pay preview
  'Gross pay preview': 'Aperçu de la paie brute',
  'Pay runs, timesheets and pay bands': 'Cycles de paie, feuilles de temps et grilles salariales',
  'Prepare, review and lock a pay period': 'Préparer, vérifier et verrouiller une période de paie',
  'Preview live calculations and CSV layouts': 'Prévisualiser les calculs actuels et les formats CSV',
  'Pay grades, rates and assignments': 'Échelons, taux et affectations salariales',
  'Recommended workflow': 'Processus recommandé',
  'Run payroll in a controlled sequence': 'Exécuter la paie selon une séquence contrôlée',
  'How payroll works': 'Fonctionnement de la paie',
  'Step {number}': 'Étape {number}',
  'Configure rates': 'Configurer les taux',
  'Set effective-dated pay bands and company payroll rules.':
    'Définissez les grilles salariales datées et les règles de paie de l’entreprise.',
  'Calculate timesheets': 'Calculer les feuilles de temps',
  'Create a pay period and calculate it from clocked shift records.':
    'Créez une période de paie et calculez-la à partir des pointages de vacation.',
  'Review and approve': 'Vérifier et approuver',
  'Resolve exceptions, add adjustments and approve every employee.':
    'Traitez les exceptions, ajoutez les ajustements et approuvez chaque employé.',
  'Lock and export': 'Verrouiller et exporter',
  'An admin locks the approved period, then exports its frozen register.':
    'Un administrateur verrouille la période approuvée, puis exporte son registre figé.',
  'Pay rates are managed by company admins.':
    'Les taux de rémunération sont gérés par les administrateurs de l’entreprise.',
  'Pay date': 'Date de paiement',
  'Choose the employee pay date.': 'Choisissez la date de paiement des employés.',
  'Start review': 'Commencer la vérification',
  'Approve every employee timesheet first.':
    'Approuvez d’abord la feuille de temps de chaque employé.',
  'Lock for export': 'Verrouiller pour export',
  'Approved — awaiting an admin lock': 'Approuvée — en attente du verrouillage par un administrateur',
  'Download locked register': 'Télécharger le registre verrouillé',
  'Current stage': 'Étape actuelle',
  'Approval progress': 'Progression des approbations',
  'Awaiting decision': 'En attente de décision',
  'Review flags': 'Signalements à vérifier',
  'Lock this approved pay period?': 'Verrouiller cette période de paie approuvée ?',
  'Locking freezes every timesheet so recalculation and adjustments cannot change the exported figures.':
    'Le verrouillage fige chaque feuille de temps afin que les recalculs et ajustements ne puissent plus modifier les montants exportés.',
  'Reason': 'Motif',
  'Return {employee} for correction': 'Renvoyer la feuille de {employee} pour correction',
  'Explain what needs to be corrected': 'Expliquez ce qui doit être corrigé',
  'Return for correction': 'Renvoyer pour correction',
  'Give a reason so the correction is clear in the audit trail.':
    'Indiquez un motif afin que la correction soit claire dans le journal d’audit.',
  'Entry date must be inside the selected pay period.':
    'La date de la ligne doit se situer dans la période de paie sélectionnée.',
  'Enter a quantity greater than zero.': 'Saisissez une quantité supérieure à zéro.',
  'Enter a rate of zero or more.': 'Saisissez un taux supérieur ou égal à zéro.',
  'Locked timesheet register downloaded and recorded in the audit trail.':
    'Le registre verrouillé des feuilles de temps a été téléchargé et consigné dans le journal d’audit.',
  'The register could not be exported or added to the audit trail.':
    'Le registre n’a pas pu être exporté ni ajouté au journal d’audit.',
  'Prepare reviewed gross-pay figures for your payroll bureau. Tax, PRSI, USC, net pay and payslips remain in your payroll provider.':
    'Préparez les montants de paie brute vérifiés pour votre prestataire. Les impôts, PRSI, USC, le net et les bulletins restent gérés par celui-ci.',
  'Estimated gross pay': 'Paie brute estimée',
  'Locked gross pay': 'Paie brute verrouillée',
  'Mixed rates': 'Taux multiples',
  'Current timesheet figures rolled up across the selected period.':
    'Montants actuels des feuilles de temps consolidés sur la période sélectionnée.',
  'Model gross pay directly from live clock records. Use Timesheets for the reviewed, locked register that becomes your payroll hand-off.':
    'Modélisez la paie brute directement depuis les pointages actuels. Utilisez les feuilles de temps pour produire le registre vérifié et verrouillé transmis à la paie.',
  'Preview gross pay': 'Prévisualiser la paie brute',
  'Generating preview...': 'Génération de l’aperçu...',
  'Preview period': 'Période de prévisualisation',
  'Choose the roster window to model. This does not create or lock a pay period.':
    'Choisissez la période de planning à modéliser. Cela ne crée ni ne verrouille une période de paie.',
  'Choose both a start and end date.': 'Choisissez une date de début et une date de fin.',
  'Start date must be on or before the end date.':
    'La date de début doit être antérieure ou égale à la date de fin.',
  'Discard changes': 'Annuler les modifications',
  'Preview out of date': 'Aperçu obsolète',
  'Live gross-pay preview — not locked': 'Aperçu actuel de la paie brute — non verrouillé',
  'The dates or payroll rules changed after this preview was generated. Generate it again before downloading.':
    'Les dates ou les règles de paie ont changé après la génération de cet aperçu. Régénérez-le avant de le télécharger.',
  'This preview uses unsaved payroll rules. Save the rules before downloading a CSV.':
    'Cet aperçu utilise des règles de paie non enregistrées. Enregistrez-les avant de télécharger un CSV.',
  'These figures come from current shift records and can still change. Final exports belong to a reviewed and locked Timesheets period.':
    'Ces montants proviennent des vacations actuelles et peuvent encore changer. Les exports définitifs doivent provenir d’une période de feuilles de temps vérifiée et verrouillée.',
  'Preview employee summary': 'Récapitulatif prévisionnel par employé',

  // Payroll tour (rendered dynamically)
  'Payroll workflow': 'Processus de paie',
  'Rates, review, approval, locking and export': 'Taux, vérification, approbation, verrouillage et export',
  'Pay preparation': 'Préparation de la paie',
  'Turn clocked shifts into reviewed employee timesheets, manage pay bands, lock approved periods and export frozen gross-pay figures for your payroll provider.':
    'Transformez les vacations pointées en feuilles de temps vérifiées, gérez les grilles, verrouillez les périodes approuvées et exportez les montants bruts figés vers votre prestataire.',
  'Onboard clients, give them portal access and manage company administrator accounts.':
    'Intégrez les clients, donnez-leur accès au portail et gérez les comptes administrateurs de l’entreprise.',
  'Prepare payroll with a clear audit trail': 'Préparer la paie avec une piste d’audit claire',
  'OdinsEye prepares gross pay for your payroll provider: configure effective-dated rates, calculate a pay period from clock records, review each employee, approve, lock, then export the frozen register.':
    'OdinsEye prépare la paie brute pour votre prestataire : configurez les taux datés, calculez une période depuis les pointages, vérifiez chaque employé, approuvez, verrouillez puis exportez le registre figé.',
  'Use this order': 'Suivez cet ordre',
  'Four controlled stages': 'Quatre étapes contrôlées',
  'This strip sits above every payroll tab, collapsed to one line until you open it. Each stage is a shortcut to where that work happens. Rate setup is admin-controlled; managers can calculate and review; only an admin can lock the approved period for export.':
    'Ce bandeau surmonte chaque onglet de paie, réduit à une seule ligne jusqu’à son ouverture. Chaque étape mène directement à l’endroit où ce travail se fait. Les taux sont gérés par les administrateurs ; les responsables calculent et vérifient ; seul un administrateur peut verrouiller la période approuvée.',
  'Rates': 'Taux',
  'Use effective-dated pay bands': 'Utiliser des grilles salariales datées',
  'Create grades and schedule rate changes from their true effective date. Keeping the rate history intact lets an earlier pay period retain the rate that applied at the time.':
    'Créez les échelons et planifiez les changements à leur date réelle d’effet. La conservation de l’historique maintient le taux applicable aux périodes antérieures.',
  'Assign every guard before calculating': 'Affecter chaque agent avant le calcul',
  'Assignments carry the pay band, employment type, payroll reference and cost centre. Unassigned employees fall back to the company rate and are flagged for review.':
    'Les affectations portent la grille, le type de contrat, la référence de paie et le centre de coûts. Les employés non affectés utilisent le taux de l’entreprise et sont signalés.',
  'Pay period': 'Période de paie',
  'Create and select the period': 'Créer et sélectionner la période',
  'Choose the period you are working on from the selector, or use New period to record fresh work dates. The bar keeps its stage, approval progress, outstanding decisions and employee pay date in view, and the full history sits under All pay periods at the foot of the page.':
    'Sélectionnez la période à traiter, ou utilisez Nouvelle période pour saisir de nouvelles dates de travail. Le bandeau garde en vue l’étape, la progression des approbations, les décisions en attente et la date de paiement ; l’historique complet se trouve sous Toutes les périodes de paie, en bas de page.',
  'Calculate': 'Calculer',
  'Build timesheets from clock records': 'Créer les feuilles de temps depuis les pointages',
  'Recalculate reads clock-ins, clock-outs, pay bands, premiums, minimum shift pay, rounding and overtime rules. Only a complete unpaid-break start and end reduce payable time; missing, incomplete or skipped breaks stay payable and are flagged. Recalculation reopens reviewed figures so changed pay must be approved again.':
    'Le recalcul lit les entrées, sorties, grilles, majorations, minimums, arrondis et heures supplémentaires. Seule une pause non payée avec un début et une fin complets réduit le temps payable ; les pauses manquantes, incomplètes ou ignorées restent payables et sont signalées. Il rouvre les montants vérifiés afin que toute modification soit de nouveau approuvée.',
  'Resolve exceptions employee by employee': 'Traiter les exceptions employé par employé',
  'Search for someone, or filter down to the sheets awaiting a decision or carrying flags. Opening a row gives you its pay lines, non-shift pay and audit trail on separate tabs, with site-local clock times. Check missing clocks, break exceptions, roster variances and fallback rates, then approve clean sheets, record an approval note for accepted exceptions, or return a sheet with a reason.':
    'Recherchez un employé, ou filtrez les feuilles en attente de décision ou signalées. L’ouverture d’une ligne présente ses lignes de paie, les éléments hors vacation et la piste d’audit dans des onglets distincts, avec les pointages à l’heure locale du site. Contrôlez les pointages manquants, les exceptions de pause, les écarts au planning et les taux de repli, puis approuvez les feuilles sans anomalie, consignez une note pour les exceptions acceptées ou renvoyez une feuille avec un motif.',
  'Control': 'Contrôle',
  'Advance one stage at a time': 'Avancer une étape à la fois',
  'Optional preview': 'Aperçu facultatif',
  'Model a live date window': 'Modéliser une période actuelle',
  'Gross pay preview is a planning tool that reads current shift data. It does not create, approve or lock a pay period, so use Timesheets for the final hand-off.':
    'L’aperçu de paie brute est un outil de planification basé sur les vacations actuelles. Il ne crée, n’approuve ni ne verrouille de période ; utilisez les feuilles de temps pour l’export définitif.',
  'Check the assumptions behind pay': 'Vérifier les hypothèses de paie',
  'The Payroll rules panel holds premiums, overtime, rounding, clock tolerances, minimum shift pay and leave accrual. It stays collapsed until you need it, and shows an unsaved badge while changes are pending. Validate configurable overtime thresholds against the applicable roster and employment terms, and save rule changes before downloading a preview CSV.':
    'Le panneau Règles de paie regroupe majorations, heures supplémentaires, arrondis, tolérances de pointage, minimums et acquisition de congés. Il reste replié jusqu’à ce que vous en ayez besoin et affiche une mention « non enregistré » tant que des modifications sont en attente. Validez les seuils d’heures supplémentaires selon le cycle de service et les conditions d’emploi applicables, et enregistrez les règles avant de télécharger un aperçu CSV.',
  'Overtime is off by default. The Security ERO bases overtime on average hours across the roster cycle, so validate these configurable thresholds against the applicable roster and employment terms before use.':
    'Les heures supplémentaires sont désactivées par défaut. L’ERO de la sécurité les fonde sur la moyenne des heures du cycle de service : validez donc ces seuils configurables selon le cycle et les conditions d’emploi applicables avant utilisation.',
  'Reconcile': 'Rapprocher',
  'Treat preview warnings as work to do': 'Traiter les avertissements de l’aperçu',
  'Generate the preview, inspect warnings and totals, and expand employees to trace the figures. If inputs change, the result is marked out of date and downloads are disabled until it is regenerated.':
    'Générez l’aperçu, contrôlez les avertissements et totaux, puis développez les employés pour retracer les montants. Si les données changent, le résultat devient obsolète jusqu’à sa régénération.',
  'Ready to run': 'Prêt à lancer',
  'Your payroll checklist': 'Votre liste de contrôle de paie',
  'Gross-pay preview generated for {range}.': 'Aperçu de la paie brute généré pour {range}.',
  'Failed to generate gross-pay preview': 'Échec de la génération de l’aperçu de paie brute',
  'Loading timesheets...': 'Chargement des feuilles de temps...',
  'Mon': 'Lun',
  'Tue': 'Mar',
  'Wed': 'Mer',
  'Thu': 'Jeu',
  'Fri': 'Ven',
  'Sat': 'Sam',
  'Monday': 'Lundi',
  'Tuesday': 'Mardi',
  'Wednesday': 'Mercredi',
  'Thursday': 'Jeudi',
  'Friday': 'Vendredi',
  'Saturday': 'Samedi',
  'Mark paid': 'Marquer comme payé',
  'Mark this pay period as paid?': 'Marquer cette période de paie comme payée ?',
  'Only do this after your payroll provider has completed the run. Paid periods remain permanently locked.':
    'Effectuez cette action uniquement après confirmation du prestataire de paie. Les périodes payées restent définitivement verrouillées.',
  'Confirm paid': 'Confirmer le paiement',
  'Entry removed.': 'Ligne supprimée.',
  'Remove this manual pay entry?': 'Supprimer cette ligne de paie manuelle ?',
  'The audit trail will retain who removed it, its description and its original value.':
    'Le journal d’audit conservera l’auteur de la suppression, la description et la valeur d’origine.',
  'Remove entry': 'Supprimer la ligne',
  'Employee pay date': 'Date de paiement des employés',
  'Save pay date': 'Enregistrer la date de paiement',
  'Pay date updated.': 'Date de paiement mise à jour.',
  'Revenue payroll reporting uses the date employees are paid.':
    'La déclaration de paie à Revenue utilise la date à laquelle les employés sont payés.',
  'Save the employee pay date before starting review.':
    'Enregistrez la date de paiement des employés avant de commencer la vérification.',
  'An admin locks and exports the period, then marks it paid after provider confirmation.':
    'Un administrateur verrouille et exporte la période, puis la marque comme payée après confirmation du prestataire.',
  'The period bar offers only the action the current stage allows: start review, approve every employee, approve the period, then have an admin lock it. Download the frozen register, and mark the period paid only after your payroll provider confirms completion.':
    'Commencez la vérification, approuvez chaque employé puis la période, et faites-la verrouiller par un administrateur. Téléchargez le registre figé et ne marquez la période comme payée qu’après confirmation du prestataire.',
  'Rates assigned, clocks complete, exceptions reviewed, employee timesheets approved, period locked and frozen register downloaded. Your provider completes tax, PRSI, USC, net pay and payslips; then an admin records the period as paid.':
    'Taux affectés, pointages complets, exceptions vérifiées, feuilles approuvées, période verrouillée et registre figé téléchargé. Le prestataire calcule impôts, PRSI, USC, net et bulletins ; un administrateur enregistre ensuite la période comme payée.',

  // Status labels (looked up dynamically, so check:i18n cannot see them)
  'Open||pay period': 'Ouverte',
  'In review||pay period': 'En révision',
  'Approved||pay period': 'Approuvée',
  'Locked||pay period': 'Verrouillée',
  'Paid||pay period': 'Payée',
  'Draft||timesheet': 'Brouillon',
  'Submitted||timesheet': 'Soumise',
  'Approved||timesheet': 'Approuvée',
  'Rejected||timesheet': 'Rejetée',
  'Locked||timesheet': 'Verrouillée',

  // Review filters, period archive and roll-up counts
  'Employee review': 'Revue par employé',
  'Search employees': 'Rechercher un employé',
  'No employees match these filters.': 'Aucun employé ne correspond à ces filtres.',
  '{shown} of {total} employees': '{shown} employés sur {total}',
  'Change': 'Modifier',
  'All pay periods': 'Toutes les périodes de paie',
  'Every period this company has run, with its approval trail.': 'Toutes les périodes traitées par cette entreprise, avec leur historique d’approbation.',
  '{count} period': '{count} période',
  '{count} periods': '{count} périodes',
  '{count} group': '{count} groupe',
  '{count} groups': '{count} groupes',

  // Shared
  'Something went wrong': 'Une erreur est survenue',
  'Working...': 'Traitement...',
  'Group': 'Groupe',
};
